import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Icon, Statistic, Card, Loader, Message } from 'semantic-ui-react';
import { Line } from 'react-chartjs-2';
import { compose } from 'recompose';
import { scientificFormat } from '../../utils/helpers/formatting';

import hasRESTClient from '../../hocs/has-rest-client';
import hasJSONAPIClient from '../../hocs/has-jsonapi-client';

const defaultDatasetProps = {
  fill: false,
  lineTension: 0.1,
  backgroundColor: 'rgba(75,192,192,0.4)',
  borderColor: 'rgba(75,192,192,1)',
  borderCapStyle: 'butt',
  borderDash: [],
  borderDashOffset: 0.0,
  borderJoinStyle: 'miter',
  pointBorderColor: 'rgba(75,192,192,1)',
  pointBackgroundColor: '#fff',
  pointBorderWidth: 1,
  pointHoverRadius: 5,
  pointHoverBackgroundColor: 'rgba(75,192,192,1)',
  pointHoverBorderColor: 'rgba(220,220,220,1)',
  pointHoverBorderWidth: 2,
  pointRadius: 1,
  pointHitRadius: 10,
};

class CampaignDashboardOverview extends Component {
  constructor() {
    super();
    this.state = {
      isLoading: true,
      isLoaded: false,
      hasFailed: false,
      overview: null,
    };
  }

  componentDidMount() {
    this.requestOverview();
  }

  requestOverview = () => {
    const { restClient, params: { id } } = this.props;
    restClient({
      method: 'post',
      url: '/campaign/overview',
      data: {
        data: { id },
      },
      timeout: 10000,
      baseURL: process.env.REACT_APP_CAMPAIGN_OVERVIEW_API_URL,
    }).then(response => {
      const { data: overview } = response;
      this.setState({
        overview,
        isLoaded: true,
        isLoading: false,
        hasFailed: false,
      });
    }).catch(() => {
      this.setState({
        overview: null,
        isLoaded: true,
        isLoading: false,
        hasFailed: true,
      });
    });
  }

  generateGraphData = items => ({
    labels: _.map(items, item => moment(item.createdDate).format('MMMM Do YYYY')),
    datasets: [
      {
        label: 'engagements',
        data: _.map(items, 'engagementsTotal'),
        ...defaultDatasetProps,
      },
    ],
  })

  render() {
    const { overview, isLoaded, isLoading, hasFailed } = this.state;
    const { campaign } = this.props;
    const { overviewHistory } = campaign;
    const graphData = this.generateGraphData(overviewHistory || []);
    return (
      <div>
        {
          isLoading && <Loader active size="large" content="Loading overview data..." />
        }
        { isLoaded && hasFailed && <Message icon="frown" error content="Something went wrong. Please try again" />}
        {
          isLoaded && !hasFailed &&
          <div>
            <Card fluid color="blue">
              <Card.Content textAlign="center">
                <Card.Header>
                  {overview.name}
                </Card.Header>
              </Card.Content>
              <Card.Content>
                <Statistic.Group widths="five">
                  <Statistic>
                    <Statistic.Value>{overview.trackedAssetCount}</Statistic.Value>
                    <Statistic.Label>Assets</Statistic.Label>
                  </Statistic>

                  <Statistic>
                    <Statistic.Value>
                      {scientificFormat(overview.engagementsTotal)}
                    </Statistic.Value>
                    <Statistic.Label>engagements</Statistic.Label>
                  </Statistic>

                  <Statistic color="pink">
                    <Statistic.Value>
                      <Icon name="user" />
                      {overview.influencerCount}
                    </Statistic.Value>
                    <Statistic.Label>influencers</Statistic.Label>
                  </Statistic>

                  <Statistic color="blue">
                    <Statistic.Value>
                      <Icon name="user" />
                      {overview.newInfluencerCount}
                    </Statistic.Value>
                    <Statistic.Label>new influencers</Statistic.Label>
                  </Statistic>

                  <Statistic>
                    <Statistic.Value>
                      {overview.membersCount}
                    </Statistic.Value>
                    <Statistic.Label>Team Members</Statistic.Label>
                  </Statistic>
                </Statistic.Group>
              </Card.Content>
              <Card.Content extra textAlign="center">
                campaign data processed: {moment.utc(overview.createdDate).calendar()}
              </Card.Content>
            </Card>
            <Card fluid>
              <Card.Content>
                <Card.Header textAlign="center">
                  Total viewing for the last 10 days
                </Card.Header>
              </Card.Content>
              <Card.Content>
                <Line data={graphData} />
              </Card.Content>
              <Card.Content extra>
                this explains the graph in some more detail
              </Card.Content>
            </Card>
          </div>
        }
      </div>
    );
  }
}

CampaignDashboardOverview.propTypes = {
  restClient: PropTypes.func.isRequired,
  params: PropTypes.object.isRequired,
  campaign: PropTypes.object.isRequired,
};

export default compose(
  hasRESTClient,
  hasJSONAPIClient,
)(CampaignDashboardOverview);



/** WEBPACK FOOTER **
 ** ./src/containers/campaign-dashboard-overview/index.js
 **/